import classNames from 'classnames';
import React from 'react';
import { v4 as uuid } from 'uuid';

import { ActionButton, ActionButtonProps, ActionLink } from '@eika/button';
import { IconTypes } from '@eika/icon';

import { paymentTrackIDs } from '../../../utils/gtm/trackIDs/payment';

import './ActionButtonGroup.scss';

type BasicLinkProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;

type ExtendedActionLinkProps = {
    hiddenOnDesktop?: boolean;
    icon: IconTypes;
    href?: string;
    /**
     * changes the background color of the button
     * @default false
     */
    isSecondary?: boolean;
} & BasicLinkProps;

type ExtendedActionButtonProps = {
    hiddenOnDesktop?: boolean;
} & ActionButtonProps;

type Action = ExtendedActionLinkProps | ExtendedActionButtonProps;

interface Props {
    actions: Action[];
    className?: string;
}

const ActionButtonGroup: React.FC<Props> = ({ actions, className }) => {
    return (
        <section
            id="action-button-group"
            className={classNames(className, 'action-button-group', { 'many-entries': actions.length > 2 })}
        >
            {actions.map(({ children, ref, hiddenOnDesktop = false, ...action }) => (
                <article
                    key={uuid()}
                    className={classNames('action-button__wrapper', { 'hidden-on-desktop': hiddenOnDesktop })}
                >
                    {'href' in action ? (
                        <ActionLink
                            {...(action as ExtendedActionLinkProps)}
                            ref={ref as React.Ref<HTMLAnchorElement> | undefined}
                            data-track-id={paymentTrackIDs.actionButton}
                            data-track-linkname={String(children)}
                        >
                            {children}
                        </ActionLink>
                    ) : (
                        <ActionButton
                            {...(action as ExtendedActionButtonProps)}
                            ref={ref as React.Ref<HTMLButtonElement> | undefined}
                            data-track-id={paymentTrackIDs.actionButton}
                            data-track-linkname={String(children)}
                        >
                            {children}
                        </ActionButton>
                    )}
                </article>
            ))}
        </section>
    );
};

export default ActionButtonGroup;
